<template>
  <div id="login">
    <div class="login_main">
      <b-container  class="mw-1 h-100">
        <div class="py-2 h-100">
          <div class="p-4 h-100">
            <b-row>
              <b-col cols="12">
                <b-row><b-col ></b-col></b-row>
                <b-row>
                  <b-col class="mb-3 text-center" cols="12">
                    <h6 class="FontNico" style="color: rgb(0, 132, 255) !important">{{companyName}}</h6>
                    <h4 class="FontNico" style="color: rgb(0, 132, 255) !important">勤怠管理システム</h4>
                  </b-col>
                  <!--  -->
                  <b-col class="mb-2" cols="12">
                    <Alert :message="validate.login" type="warning" class="mb-2"></Alert>
                  </b-col>
                  <!-- ユーザID -->
                  <b-col cols="12">
                    <b-form-group>
                      <b-form-input
                        id="shain-id"
                        ref="focusUserId"
                        v-model="form.user"
                        placeholder="ユーザーID"
                        class="WorkM_LoginInfo__Input"
                      ></b-form-input>
                      <Alert :message="validate.user" type="warning" class="mt-2"></Alert>
                    </b-form-group>
                  </b-col>
                  <!-- パスワード -->
                  <b-col cols="12">
                    <b-form-group>
                      <b-form-input
                        id="pass"
                        ref="focusPassword"
                        type="password"
                        v-model="form.pw"
                        placeholder="パスワード"
                        class="WorkM_LoginInfo__Input"
                      ></b-form-input>
                      <Alert :message="validate.pw" type="warning" class="mt-2"></Alert>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col><b-check v-model="rememberFlg" class="text-muted">ユーザーIDを記憶する</b-check></b-col>
                </b-row>
                <div></div>
                <div class="mt-4">
                  <div class="text-center">
                    <b-button class="px-4 button_round_style" style="border-radius: 20px" variant="primary" @click="loginBtnHandler"
                      >ログイン</b-button
                    >
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import config from "../../const/config.js";
import Alert from "../../components/Parts/Alert";

export default {
  name: "Login",
  components: {
    Alert,
  },
  data() {
    return {
      form: {
        user: null,
        pw: null,
      },
      validate: {
        login: null,
        user: null,
        pw: null,
      },
      hasError: false,
      rememberFlg: true,
      companyName: "",
      nextPage: "",
    };
  },
  mounted: function () {
    //状態をログアウトとする
    this.$store.commit("logout");
    //
    this.$refs.focusPassword.focus();

    // --- 契約者コードを記憶していた場合
    if (localStorage.WorkM_remember_user_id) {
      this.form.user = localStorage.WorkM_remember_user_id;
    } else {
      this.$refs.focusUserId.focus();
    }

    // APIの呼び出し
    this.getLoginInfo();
  },
  updated() {
    this.$nextTick(function() {
      // --- ログイン後遷移先のQueryParameterが指定されていれば、指定ページに遷移できるように確保
      this.nextPage = this.$route.query.next;
    })
  },
  methods: {
    //
    setRememberValue: function () {},
    /**
     * ログインボタン押下時
     */
    loginBtnHandler: function () {
      if (!this.executeValidate()) {
        return;
      }
      //
      this.postData(config.URL.LOGIN, this.form)
        .then((respons) => {
          console.debug(respons);
          this.loginSuccessHandler();
        })
        .catch((e) => {
          if (e && e.response && e.response.status == 403) {
            this.showAlertError("ログインできません。ユーザーID、パスワードをご確認ください。", "認証エラー");
          }
        })
        .finally(() => {});
    },
    /**
     * クライアントバリデーション実施
     */
    executeValidate() {
      this.clearValidateMessage();
      let valid = true;
      if (this.form.user == null || this.form.user.length <= 0) {
        this.validate.user = "ユーザーIDを入力してください。";
        valid = false;
      }
      if (this.form.pw == null || this.form.pw.length <= 0) {
        this.validate.pw = "パスワードを入力してください。";
        valid = false;
      }
      return valid;
    },

    /**
     * バリデートメッセージの初期化
     */
    clearValidateMessage() {
      this.validate.login = null;
      this.validate.user = null;
      this.validate.pw = null;
    },

    /**
     * ログイン成功後の処理
     */
    loginSuccessHandler() {
      //クライアント側で保持が必要なユーザ情報を取得し、Vueストアに保持しておく
      this.getData(config.URL.LOGIN_SYSTEM_USER, this.form.user)
        .then((response) => {
          if (response.result) {
            //正常
            this.loginComplete(response.container);
          } else {
            this.showAlertError("ログイン情報の取得に失敗しました。再度ログインしてください。");
          }
        })
        .catch((e) => {
          // Note: エラーメッセージは、共通処理で表示している
          console.error(e);
        })
        .finally(() => {});
    },
    /***ログイン完了時処理 */
    loginComplete: function (userContainer) {
      //Vuexに保持
      let storeSetParam = {
        user_id: userContainer.user_id,
        user_name: userContainer.user_name,
        system_authority_type: userContainer.system_authority_type,
        flg_allocation_calc: userContainer.flg_allocation_calc,
      };
      this.$store.commit("setLoginUserInfo", storeSetParam);
      this.$store.commit("login");

      //次回ログイン保持
      if (this.rememberFlg) {
        localStorage.WorkM_remember_user_id = this.form.user;
      } else {
        localStorage.removeItem("WorkM_remember_user_id");
      }
      //遷移
      switch (this.nextPage) {
        case "application_approval":
          this.$router.push("/manager/Approval?type=1");
          break;
        case "work_approval":
          this.$router.push("/manager/Approval?type=2");
          break;
        case "application":
          this.$router.push("/manager/ApplicationRegist");
          break;
        case "work_info":
          this.$router.push("/manager/WorkRegist");
          break;
        default:
          this.$router.push("/manager/Home");
          break;
      }
    },

    // 会社名を取得するAPI
    getLoginInfo(){
      this.getData(config.URL.LOGIN_INFO)
        .then((response) => {
          // レスポンスの結果がfalseならエラーメッセージを表示
          if(!response.result){
            this.showAlertError(config.MESSAGE.SERVER_ERROR);
            return;
          }
          console.debug("response：" + JSON.stringify(response));
          this.setLoginInfo(response.container);
        })
        .catch((e) => {
          // Note: エラーメッセージは、共通処理で表示している
          console.error(e);
        })
        .finally(() => {});
    },
    setLoginInfo(item){
      this.companyName = item.companyName;
    }
  },
};
</script>

<style>

html {
  height: 100%;
}

body {
  height: 100%;
  margin: 0;
}

#work_manage, #login, .login_main{
  height: 100%;
}

/* ログイン画面 カードヘッダ */
#work_manage .login_cardheader {
  background: var(--mainColor);
  color: white;
}

#login .login_main {
  max-width: 500px;
  margin: 0 auto;
}

#login .errorMsg {
  font-size: 13px;
}

/**入力ボックス*/
.WorkM_LoginInfo__Input {
  border: none !important;
  border-bottom: 1px solid silver !important;
  border-radius: 0 !important;
}
</style>
